<template>
  <v-container>
    <h1>Admin Controls</h1>

    <v-layout row>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'AdminAnalytics'})" >
          Analytics
        </v-card>
      </v-flex>
      <v-flex xs12 sm3>
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'ManageUsers'})">
          User Management
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'CSVImporter'})">
          CSVImporter
        </v-card>
      </v-flex>


      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'DataExport'})">
          Data Export
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'CohortManagement'})">
          Cohort Management
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'ContentImporter'})">
          Content Importer
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'DataManagement'})">
          Data Management
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 v-if="$store.getters.verifyAdmin">
        <v-card hover outlined class="ma-3 pa-5" @click="$router.push({name:'AdminManagement'})">
          Admin Management
        </v-card>
      </v-flex>      
    </v-layout>








    <v-card class="pa-2" v-if="$store.getters.verifyAdmin">
      <v-card-title>Query User Deck Data</v-card-title>
      <v-layout wrap>
        <v-flex xs12, sm6 class="pa-5">
          <v-text-field outlined label="uid" v-model="userDeckQuery.uid"></v-text-field>
        </v-flex>
        <v-flex xs12, sm6 class="pa-5">
          <v-text-field outlined label="deckId" v-model="userDeckQuery.deckId"></v-text-field>
        </v-flex>
        <v-btn class="ml-5" @click="runUserDeckQuery()">Run Query</v-btn>

      </v-layout>
      <v-card flat outlined class="ma-5 pa-3">
      {{userDeckQuery.result}}
      </v-card>




    </v-card>


    <v-expansion-panels v-if="$store.getters.verifyAdmin">
      <v-expansion-panel>
        <v-expansion-panel-header>User Management</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            outlined
            label="Search"
            >

            <v-row>

            </v-row>

          </v-text-field>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


    <v-card v-if="$store.getters.verifyAdmin">
      <v-card-title>
        Image Content
      </v-card-title>
      <v-btn @click="getAllCardData()">Get All Cards</v-btn>
    </v-card>
    <v-card v-if="$store.getters.verifyAdmin">
      <v-card-title>
        Review Card History
      </v-card-title>
      <v-text-input label="Deck Id" v-model="deckIdForCardReview">
      <v-btn @click="getCardHistory('nvhOZscL5EhvrAVekmXr')">Get History</v-btn>

      <v-card v-for="(data,id) in groupsOfEdits" :key="id">
        {{id}}

        <v-card v-for="(card, index) in data" :key="index">
          <cardQuestionAnswer :card="card"/>
          {{card}}
          {{index}}
        </v-card>




      </v-card>

      </v-text-input>
    </v-card>

  </v-container>

</template>
<script>
import firebase from 'firebase'
import moment from 'moment'
import _ from 'underscore'
import cardQuestionAnswer from '@/components/cardQuestionAnswer.vue'
import LineChart from '@/components/LineChart.vue'


export default {
  name: 'Admin',
  components: {
    cardQuestionAnswer,
    LineChart

  },
  data() {
    return {
      userDeckQuery: {
        uid: "",
        deckId: "",
        result: "...",
      },
      deckIdForCardReview: 'nvhOZscL5EhvrAVekmXr',
      groupsOfEdits: null,
      allCards: [],
      usage: null,
      chartOptions: {
  				responsive: true,
  				title: {
  					display: true,
  					text: 'Omentum Use'
  				},
  				scales: {
  					xAxes: [{
  						type: 'time',
              time: {
                unit: 'day',
              },
  						display: true,
  						scaleLabel: {
  							display: true,
  							labelString: 'Date'
  						},
  						ticks: {
                min: moment().subtract(20, 'days').format(),
                max: moment().add(0, 'days').format(),
  						}
  					}],
  					yAxes: [{
  						display: true,
  						scaleLabel: {
  							display: true,
  							labelString: 'Number of cards'
  						}
  					}]
  				}
  			},
        chartData: {
          labels: ['date'],
          datasets: [
            {
    					label: 'Cards By Hour',
              backgroundColor: 'rgb(235, 151, 78, 1)',
              borderColor: 'rgb(235, 151, 78, 1)',
    					fill: false,
              data: [
                {x: moment().format(), y: 10}
              ]

    			}]
        },
        chartKey: 0

    }
  },
  methods: {
    getDeckUsage() {
      firebase.firestore().collection('activityLog')
      .where('timestamp', '>', moment().subtract(20, 'days').toDate())
      .get().then(snapshot => {
        this.usage = {}
        this.chartData.datasets[0].data = []
        snapshot.forEach(doc => {
          let data = doc.data()
          let sum = 0
          for (let item in data) {
            if (item != 'timestamp') {
              sum += data[item].length
            }
          }
          this.usage[doc.id] = sum
          this.chartData.datasets[0].data.push({x: doc.id, y: sum})
        })
        this.chartKey += 1

      })

    },


    runUserDeckQuery() {
      firebase.firestore().collection('learningRecord')
      .doc(this.userDeckQuery.uid)
      .collection('deckRecord')
      .doc(this.userDeckQuery.deckId)
      .get().then(doc => {
        this.userDeckQuery.result = JSON.stringify(doc.data())

      })

    },
    getAllCardData() {
      firebase.firestore().collection('cards').get().then(snapshot => {
        snapshot.forEach(doc => {
          let data  = doc.data()
          data.id = doc.id
          this.allCards.push(data)

        })

        let final = this.allCards.filter(item => {
          return JSON.stringify(item).includes('learn-med')
        })
        let groups = _.groupBy(final, 'deck')
        console.log(Object.keys(groups))
      })
    },

/*

==old content===
0: "M6S22VAj4zPOUSKPSyrV"
1: "ftDBmIxXLmxRcHzQkqIS"
2: "KasMSFteKAmHbjna5cFg"
3: "1RbMU1KrcLQfQ24EFxuM"

==not found==
4: "9osQ3D4NSPVfD3ctsxoN"
5: "0QdqMvPFYy5ks1SGO3Oc"
6: "m9uMw0yOwUU2AzYbc1Tq"
length: 7
*/

    getCardHistory(deckId) {
      firebase.firestore().collection('contentHistory')
      .doc(deckId).collection('cardEdits')
      .get().then(snapshot => {
        let data = []
        snapshot.forEach(doc => {
          data.push(doc.data())
        })
        let cards = _.groupBy(data, 'id')
        let cardList = Object.keys(cards)
        return {cards, cardList}
      }).then(result => {
        console.log(result)
      })

    }
  }
}
</script>
<style>

</style>
